// client/src/components/pacotesCliente/PacoteClienteRow.js
import React from 'react';
import { MoreVertical } from 'lucide-react';
import { useTenantI18n } from '../../hooks/useAccounts';
import { formatCurrency as formatCurrencyUtil } from '../../utils/formatters';

const PacoteClienteRow = ({ pacote, onOpenActions, loading }) => {
    // ✅ ACHADO: fixo em BRL, sem ler configuracoesGerais.i18n da conta.
    const { currency, locale } = useTenantI18n();
    const formatCurrency = (value) => formatCurrencyUtil(value || 0, currency, locale);
    const getStatusClass = (status) => {
        switch (status) {
            case 'Ativo': return 'badge-green';
            case 'Concluído': return 'badge-gray';
            case 'Cancelado': return 'badge-red';
            case 'Expirado': return 'badge-yellow';
            case 'Suspenso': return 'badge-yellow';
            default: return 'badge-gray';
        }
    };

    const sessoesUtilizadas = pacote.quantidadeSessoesUtilizadas ?? (pacote.sessoesUtilizadas?.length || 0);
    const sessoesContratadas = pacote.pacoteComprado?.sessoes || 0;

    return (
        <tr className="table-row hover:bg-gray-50 transition-colors duration-150">
            <td className="table-cell">{pacote.cliente?.user?.name || 'Cliente não encontrado'}</td>
            <td className="table-cell">{pacote.oferta?.nome || 'Oferta não encontrada'}</td>
            <td className="table-cell">
                <div className="flex flex-col">
                    <span className="font-medium">{pacote.pacoteComprado?.nome || 'Pacote'}</span>
                    <span className="text-sm text-gray-500">{formatCurrency(pacote.pacoteComprado?.valor)}</span>
                </div>
            </td>
            <td className="table-cell">
                <span className="font-semibold">{sessoesUtilizadas}</span> / {sessoesContratadas}
            </td>
            <td className="table-cell">{pacote.dataDaCompra ? new Date(pacote.dataDaCompra).toLocaleDateString('pt-BR') : '—'}</td>
            <td className="table-cell">{pacote.dataValidade ? new Date(pacote.dataValidade).toLocaleDateString('pt-BR') : '—'}</td>
            <td className="table-cell">
                <span className={`badge ${getStatusClass(pacote.status)}`}>
                    {pacote.status}
                </span>
            </td>
            <td className="text-right">
                <button onClick={() => onOpenActions(pacote)} title="Ações" className="action-button-icon text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed" disabled={loading}>
                    <MoreVertical size={18} />
                </button>
            </td>
        </tr>
    );
};

export default PacoteClienteRow;
